import { render } from "./ItemMetadata.vue?vue&type=template&id=32b3f794&scoped=true"
import script from "./ItemMetadata.vue?vue&type=script&lang=js"
export * from "./ItemMetadata.vue?vue&type=script&lang=js"

import "./ItemMetadata.vue?vue&type=style&index=0&id=32b3f794&scoped=true&lang=css"

import exportComponent from "/home/elias/web-farm/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32b3f794"]])

export default __exports__